import { render, staticRenderFns } from "./AccountLogin.vue?vue&type=template&id=bfc679c8"
import script from "./AccountLogin.vue?vue&type=script&lang=js"
export * from "./AccountLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports